import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Field } from 'formik'

import FormControl from '@material-ui/core/FormControl';
import Select from './SelectMUI'
import SelectOrInput from './SelectOrInputMUI'
import Typography from '@material-ui/core/Typography'

const PhoneFields = ({
  staticData,
  form,
  namePhoneTypeId,
  namePhoneNum,
  label,
  options,
  className,
  variant
}) => {

  return (
      <FormControl className={className} fullWidth>
        {label && <Typography className='label' gutterBottom>{label}</Typography>}
        <div className='phone-fields'>
          <Field
            variant={variant}
            className={'phone-type'}
            form={form}
            name={namePhoneTypeId}
            itemToString={item => item && item.name}
            options={staticData.phoneTypes}
            component={Select}
          />

          <Field 
            variant={variant}
            className={'phone'}
            form={form}
            name={namePhoneNum}
            options={options}
            component={SelectOrInput} />
        </div>
      </FormControl>
  )
}

PhoneFields.propTypes = {
  staticData: PropTypes.object,
  form: PropTypes.object,
  namePhoneTypeId: PropTypes.string,
  namePhoneNum: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  options: PropTypes.array,
  className: PropTypes.string,
  variant: PropTypes.string
}

export default inject('staticData')(observer(PhoneFields))
